import { createFileRoute, Outlet } from '@tanstack/react-router';
import { RiskAssessment } from '../RiskAssessment';
import { useRiskEditAccess } from '../useRiskEditAccess';

export const Route = createFileRoute('/console/$orgId/risk/register/details/$id/assessment')({
    component: RouteComponent,
});

function RouteComponent() {
    const { id } = Route.useParams();
    const { canEdit } = useRiskEditAccess();

    return (
        <>
            <RiskAssessment riskId={id} readonly={!canEdit} />
            <Outlet />
        </>
    );
}
